export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/requisitions-pdf/${id}`,
    });
  },
});
